export const STICKERS_PANEL_TOOLTIPS = [
  {
    id: 'stickers-tool',
    cookieKey: 'editor_tip_stickers_tool',
    title: 'Stickers',
    description:
      'Select a sticker, then click on the image to place it. Tap a placed sticker to select it.',
    placement: 'top',
    align: 'center',
    delayAfterClose: 1800,
  },
];
